// ZIP sin compresion (metodo 0): basta para .docx y .xlsx y no necesita librerias.
const TABLA_CRC = (() => {
  const t = new Uint32Array(256);
  for (let n = 0; n < 256; n++) {
    let c = n;
    for (let k = 0; k < 8; k++) c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    t[n] = c >>> 0;
  }
  return t;
})();
export function crc32(d: Uint8Array) {
  let c = 0xffffffff;
  for (const b of d) c = TABLA_CRC[(c ^ b) & 0xff] ^ (c >>> 8);
  return (c ^ 0xffffffff) >>> 0;
}

export function zip(archivos: [string, string | Uint8Array][]): Uint8Array<ArrayBuffer> {
  const enc = new TextEncoder();
  const locales: Uint8Array[] = [];
  const centrales: Uint8Array[] = [];
  let pos = 0;
  for (const [nombre, contenido] of archivos) {
    const n = enc.encode(nombre);
    const d = typeof contenido === 'string' ? enc.encode(contenido) : contenido;
    const crc = crc32(d);
    const loc = new Uint8Array(30 + n.length);
    const v = new DataView(loc.buffer);
    v.setUint32(0, 0x04034b50, true);
    v.setUint16(4, 20, true);
    v.setUint16(6, 0x0800, true); // nombres en UTF-8
    v.setUint32(14, crc, true);
    v.setUint32(18, d.length, true);
    v.setUint32(22, d.length, true);
    v.setUint16(26, n.length, true);
    loc.set(n, 30);
    const cen = new Uint8Array(46 + n.length);
    const w = new DataView(cen.buffer);
    w.setUint32(0, 0x02014b50, true);
    w.setUint16(4, 20, true);
    w.setUint16(6, 20, true);
    w.setUint16(8, 0x0800, true);
    w.setUint32(16, crc, true);
    w.setUint32(20, d.length, true);
    w.setUint32(24, d.length, true);
    w.setUint16(28, n.length, true);
    w.setUint32(42, pos, true);
    cen.set(n, 46);
    locales.push(loc, d);
    centrales.push(cen);
    pos += loc.length + d.length;
  }
  const tamCentral = centrales.reduce((s, x) => s + x.length, 0);
  const fin = new Uint8Array(22);
  const f = new DataView(fin.buffer);
  f.setUint32(0, 0x06054b50, true);
  f.setUint16(8, archivos.length, true);
  f.setUint16(10, archivos.length, true);
  f.setUint32(12, tamCentral, true);
  f.setUint32(16, pos, true);
  const out = new Uint8Array(pos + tamCentral + 22);
  let i = 0;
  for (const x of [...locales, ...centrales, fin]) {
    out.set(x, i);
    i += x.length;
  }
  return out;
}
